export const LOGIN_ROUTE = "/tower-head-admin";
export const FORGOT_ROUTE = "/tower-head-admin/forgot-password";
export const DASHBOARD_ROUTE = "/tower-head-admin/dashboard";
export const MENU_PRICE = "/tower-head-admin/menu-pricing";
export const EXCEL_PRODUCT = "/tower-head-admin/excel-products";



export const OTP_ROUTE = "/tower-head-admin/otps";
export const CREATE_ADMIN_ROUTE = "/tower-head-admin/admins";

export const PROFILE_ROUTE = "/tower-head-admin/otps";
export const ROUTE1 = "/tower-head-admin/otps";
export const COMMON1 = "/tower-head-admin/common";
export const COMMON2 = "/tower-head-admin/common2";
export const COMMON3 = "/tower-head-admin/common3";
export const COMMON4 = "/tower-head-admin/common4";
export const COMMON5 = "/tower-head-admin/common5";
export const COMMON6 = "/tower-head-admin/common6";


export const PRODUCT_ROUTE = "/tower-head-admin/products";
export const MEALS_ROUTES = "/tower-head-admin/meals";
export const REVENUE_ROUTES = "/tower-head-admin/revenues";
export const TOP_SELLING_ROUTES = "/tower-head-admin/top-selling-products";
export const EMP_ROUTES = "/tower-head-admin/emp-feed";
export const EMP_USAGE_ROUTES = "/tower-head-admin/no-of-app-users";




export const CAFETERIA_INVENTORY_ROUTE ="/tower-head-admin/cafeteria-inventory"
export const VENDOR_ROUTE ="/tower-head-admin/vendor"
export const VENDOR_MANAGER_ROUTE ="/tower-head-admin/vendor-manager"
export const VENDOR_COMPLIANCE_ROUTE ="/tower-head-admin/vendor-compliance"
export const GALLERY_ROUTE ="/tower-head-admin/gallery"


export function  PRODUCT_BY_EXCEL(id){
   return `/tower-head-admin/excel-products/${id}`;
}